module.exports = __webpack_public_path__ + "static/media/c.efe16e50.png";